export type CalendarDayKind = 'holiday' | 'bridge';

export interface MarkedDay {
    date: string;
    kind: CalendarDayKind;
}

export const HOLIDAY_SAMPLE_YEAR = 2026;
export const HOLIDAY_SAMPLE_MONTHS = [5, 6];

export const BADEN_WUERTTEMBERG_2026: MarkedDay[] = [
    { date: '2026-05-01', kind: 'holiday' },
    { date: '2026-05-14', kind: 'holiday' },
    { date: '2026-05-15', kind: 'bridge' },
    { date: '2026-05-25', kind: 'holiday' },
    { date: '2026-06-04', kind: 'holiday' },
    { date: '2026-06-05', kind: 'bridge' }
];
